import {css, getSimilarColor} from '../utils.js';

const styles = css`
    .control-panel-left {
        background-color: ${({theme}) => theme.background_page};
    }
    .control-panel-left.expanded {
        width: 312px;
        border-right: 1px solid ${({theme}) => theme.card_border.color};
    }
    .control-panel-left.collapsed {
        width: 0px;
    }

    .control-panel-top {
        /* We are disabling the sticky controls until we can come up with a
        better solution to this issue:
        github.com/plotly/notebook-to-app/issues/1508 */
        /* position: sticky; */
        /* z-index: 2; */ /* needs to be 2, because ag-grid's resize bars are 1 */
        /* top: 0; */
        background-color: ${({theme}) => theme.card_header_background_color};
    }
    .control-panel-top.expanded {
        box-shadow: ${({theme}) => theme.card_box_shadow};
        border-bottom: ${props => {
            const border = props.theme.top_control_panel_border;
            return border
                ? `${border.width} ${border.style} ${border.color}`
                : 'none';
        }};
    }
    .control-panel-top.collapsed {
        width: 0px;
        float: left;
    }

    .control-panel-left .control-panel-header {
        font-size: 16px;
        display: flex;
        padding: 12px 6px;
        align-items: center;
        gap: 12px;

        position: sticky;
        top: 0;
        /* Control Panel Header should sit on top of accordion header when the
        footer pushes the sticky accordion header up. */
        z-index: 1;
    }
    .control-panel-top .control-panel-header {
        margin: 12px 0 12px 6px;
        float: left;

        position: sticky;
        top: 12px;
    }
    .control-panel.expanded .control-panel-header {
        background-color: ${({theme}) => theme.card_header_background_color};
    }

    .control-panel-toggle {
        /* button reset */
        overflow: visible;
        font: inherit;
        text-align: inherit;
        line-height: normal;
        -webkit-font-smoothing: inherit;
        -moz-osx-font-smoothing: inherit;
        -webkit-appearance: none;
        appearance: none;

        /* custom styles */
        width: 36px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;

        /* Our CSS utility function doesn't allow nesting like styled-components
        does, so we're adding a conditional check to each CSS prop. */
        color: ${({theme}) =>
            theme.color_scheme === 'light'
                ? theme.button_border.color
                : getSimilarColor(theme.button_border.color, 'brighten', 80)};
        border: 1px solid
            ${({theme}) =>
                theme.color_scheme === 'light'
                    ? theme.button_border.color
                    : getSimilarColor(
                          theme.button_border.color,
                          'brighten',
                          80
                      )};
        background-color: ${({theme}) =>
            theme.color_scheme === 'light'
                ? getSimilarColor(theme.button_border.color, 'brighten', 80)
                : theme.button_border.color};
    }

    .control-panel.collapsed .control-panel-toggle {
        box-shadow:
            0px 20px 6px 0px rgba(0, 0, 0, 0),
            0px 13px 5px 0px rgba(0, 0, 0, 0.01),
            0px 7px 4px 0px rgba(0, 0, 0, 0.05),
            0px 3px 3px 0px rgba(0, 0, 0, 0.09),
            0px 1px 2px 0px rgba(0, 0, 0, 0.1);
    }

    /* Certain overrides for global controls */

    /* .Select-menu-outer is the dropdown menu where you can select more items */
    .ddk-container
        .control-panel-left
        .global-controls-bar-item-control
        .Select-menu-outer {
        /* Don't use absolute position for the accordion. It does not play
        nicely with overflow: hidden, which we use extensively in the accordion
        component.  */
        position: relative;
        border-top: 1px solid ${({theme}) => theme.accent};
    }
    .ddk-container
        .control-panel-top
        .global-controls-bar-item-control
        .Select-menu-outer {
        /* In the top ControlPanel we can still use absolute positioning, as we do not use overflow: hidden. */
        /* Add some additional room for the accent-color border */
        top: calc(100% + var(--ddk-grid-quarter));
    }
`;

export default styles;
